import { createContext } from 'react';
import type { GridHistoryEntry } from './history';

/**
 * The latest change a page made around its grids (renaming, moving or hiding a
 * sheet tab), for whichever grid is showing to put on its undo stack. A grid
 * takes only entries that arrive while it is mounted.
 */
export const GridHistoryEntryContext = createContext<GridHistoryEntry | undefined>(undefined);
